export default __webpack_public_path__ + "static/media/pin.acd11a8e.svg";